import { useQuery } from '@tanstack/react-query'

import { ApiResponse, IReferenceGroup } from '@/_types'

export const useGetReferenceGroup = (slug: string) => {
	return useQuery({
		queryKey: ['reference-group', slug],
		queryFn: (): Promise<ApiResponse<IReferenceGroup>> =>
			fetch(`${process.env.NEXT_PUBLIC_API_URL}/v1/web/reference/groups/${slug}`).then(res => {
				if (!res.ok) {
					throw new Error('Failed to fetch reference group')
				}

				return res.json()
			}),
		select: data => data.data
	})
}
